import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      headers: [
        {
          text: 'تاریخ',
          value: 'date',
          align: 'center',
          style: 'width:160px;min-width:160px;max-width:160px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'شناسه ماموریت',
          value: 'missionId',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'آدرس',
          value: 'missionAddress',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'اولویت',
          value: 'missionRank',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'نوع محل ماموریت',
          value: 'geographicalTypeTitle',
          align: 'center',
          style: 'width:100px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'نوع وسیله نقلیه',
          value: 'phoneVehicleType',
          align: 'center',
          style: 'width:120px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'نوع کد',
          value: 'phoneStationGeographicalTypeTitle',
          align: 'center',
          style: 'width:120px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'پاسخ تا ارسال به 800',
          value: 'answerToReciveBy800',
          align: 'center',
          style: 'width:210px;min-width:210px;max-width:210px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'رسیدن به 800 تا ابلاغ',
          value: 'recivedBy800ToSend',
          align: 'center',
          style: 'width:210px;min-width:210px;max-width:210px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'ابلاغ تا حرکت',
          value: 'sendToMove',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'حرکت تا رسیدن',
          value: 'moveToArrive',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'حضور در محل',
          value: 'stayInPlace',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'محل تا بیمارستان',
          value: 'placeToHospital',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'حضور در بیمارستان',
          value: 'stayInHospital',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'مدت ماموریت',
          value: 'missionTime',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'کارشناس ارشد',
          value: 'mainUser',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'کارشناس اول',
          value: 'firstUser',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'کارشناس دوم',
          value: 'secondUser',
          align: 'center',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: true,
          isGroupable: true,
        },
        {
          text: 'اعزام مجدد',
          value: 'sendAgain',
          align: 'start',
          style: 'width:190px;min-width:190px;max-width:190px',
          sortState: 1,
          isSortable: false,
          isGroupable: false,
        },
        {
          text: 'فاقدی',
          value: 'lackof',
          align: 'start',
          style: 'width:150px;min-width:150px;max-width:150px',
          sortState: 1,
          isSortable: false,
          isGroupable: false,
        },
      ],
      tableItems: [],
      searchFirstUserId: null,
      searchSecondUserId: null,
      searchPhoneCode: null,
      searchVehicleTypeId: null,
      searchCityId: null,
      /**********************************************/
      searchDispatchTillMoveMinimumSecond: null,
      searchDispatchTillMoveMinimumMinute: null,
      /**********************************************/
      searchMoveTillArriveMinimumSecond: null,
      searchMoveTillArriveMinimumMinute: null,
      /**********************************************/
      searchPatientWaitingDurationMinimumSecond: null,
      searchPatientWaitingDurationMinimumMinute: null,
      /**********************************************/
      searchHospitalWaitingDurationMinimumSecond: null,
      searchHospitalWaitingDurationMinimumMinute: null,
      /**********************************************/
      searchMissionDurationMinimumSecond: null,
      searchMissionDurationMinimumMinute: null,
      searchMissionDurationMinimumHoure: null,
      /**********************************************/
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        let answerTillCreation = null;
        if (data[i].answerTillCreation) {
          answerTillCreation = Math.round(data[i].answerTillCreation);
          answerTillCreation = answerTillCreation * 1000;
        }
        let dispatchDeliveryTillDispatch = null;
        if (data[i].dispatchDeliveryTillDispatch) {
          dispatchDeliveryTillDispatch = Math.round(data[i].dispatchDeliveryTillDispatch);
          dispatchDeliveryTillDispatch = dispatchDeliveryTillDispatch * 1000;
        }
        let dispatchTillMove = null;
        if (data[i].dispatchTillMove) {
          dispatchTillMove = Math.round(data[i].dispatchTillMove);
          dispatchTillMove = dispatchTillMove * 1000;
        }
        let moveTillArrive = null;
        if (data[i].moveTillArrive) {
          moveTillArrive = Math.round(data[i].moveTillArrive);
          moveTillArrive = moveTillArrive * 1000;
        }
        let patientWaitingDuration = null;
        if (data[i].patientWaitingDuration) {
          patientWaitingDuration = Math.round(data[i].patientWaitingDuration);
          patientWaitingDuration = patientWaitingDuration * 1000;
        }
        let moveFromPlaceTillArriveToHospital = null;
        if (data[i].moveFromPlaceTillArriveToHospital) {
          moveFromPlaceTillArriveToHospital = Math.round(data[i].moveFromPlaceTillArriveToHospital);
          moveFromPlaceTillArriveToHospital = moveFromPlaceTillArriveToHospital * 1000;
        }
        let hospitalWaitingDuration = null;
        if (data[i].hospitalWaitingDuration) {
          hospitalWaitingDuration = Math.round(data[i].hospitalWaitingDuration);
          hospitalWaitingDuration = hospitalWaitingDuration * 1000;
        }
        let deliveryTillFinish = null;
        if (data[i].deliveryTillFinish) {
          deliveryTillFinish = Math.round(data[i].deliveryTillFinish);
          deliveryTillFinish = deliveryTillFinish * 1000;
        }
        let mainUser = '';
        if (data[i].firstUser) {
          let fname = data[i].firstUser.firstName;
          let lName = data[i].firstUser.lastName;
          mainUser = fname + ' ' + lName;
        }
        let firstUser = '';
        if (data[i].secondUser) {
          let fname = data[i].secondUser.firstName;
          let lName = data[i].secondUser.lastName;
          firstUser = fname + ' ' + lName;
        }
        let secondUser = '';
        if (data[i].thirdUser) {
          let fname = data[i].thirdUser.firstName;
          let lName = data[i].thirdUser.lastName;
          secondUser = fname + ' ' + lName;
        }
        this.tableItems.push({
          date: date,
          missionId: data[i].missionPhoneIdentifier ? data[i].missionPhoneIdentifier : '-',
          ambulanceCode: data[i].phoneCode ? data[i].phoneCode : '-',
          answerToReciveBy800: this.msToTime(answerTillCreation),
          recivedBy800ToSend: this.msToTime(dispatchDeliveryTillDispatch),
          sendToMove: this.msToTime(dispatchTillMove),
          moveToArrive: this.msToTime(moveTillArrive),
          stayInPlace: this.msToTime(patientWaitingDuration),
          placeToHospital: this.msToTime(moveFromPlaceTillArriveToHospital),
          stayInHospital: this.msToTime(hospitalWaitingDuration),
          missionTime: this.msToTime(deliveryTillFinish),
          mainUser: mainUser ? mainUser : '-',
          missionAddress: data[i]?.missionAddress,
          phoneVehicleType: data[i]?.phoneVehicleType,
          geographicalTypeTitle: data[i]?.geographicalTypeTitle,
          phoneStationGeographicalTypeTitle: data[i]?.phoneStationGeographicalTypeTitle,
          missionRank: data[i]?.missionRank,
          firstUser: firstUser ? firstUser : '-',
          secondUser: secondUser ? secondUser : '-',
          sendAgain: data[i].is1051,
          lackof: data[i].lackOfCode,
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    sortStatus: function (data) {
      if (data.sortState == 1) {
        data.sortState = 2;
      } else if (data.sortState == 2) {
        data.sortState = 1;
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCMissionTimesReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchFirstUserId,
        this.searchSecondUserId,
        this.searchPhoneCode,
        this.searchVehicleTypeId,
        this.searchCityId,
        this.searchDispatchTillMoveMinimumSecond,
        this.searchDispatchTillMoveMinimumMinute,
        this.searchMoveTillArriveMinimumSecond,
        this.searchMoveTillArriveMinimumMinute,
        this.searchPatientWaitingDurationMinimumSecond,
        this.searchPatientWaitingDurationMinimumMinute,
        this.searchHospitalWaitingDurationMinimumSecond,
        this.searchHospitalWaitingDurationMinimumMinute,
        this.searchMissionDurationMinimumSecond,
        this.searchMissionDurationMinimumMinute,
        this.searchMissionDurationMinimumHoure,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchFirstUserId = null;
      this.searchSecondUserId = null;
      this.searchPhoneCode = null;
      this.searchVehicleTypeId = null;
      this.searchCityId = null;
      this.searchDispatchTillMoveMinimumSecond = null;
      this.searchDispatchTillMoveMinimumMinute = null;
      this.searchMoveTillArriveMinimumSecond = null;
      this.searchMoveTillArriveMinimumMinute = null;
      this.searchPatientWaitingDurationMinimumSecond = null;
      this.searchPatientWaitingDurationMinimumMinute = null;
      this.searchHospitalWaitingDurationMinimumSecond = null;
      this.searchHospitalWaitingDurationMinimumMinute = null;
      this.searchMissionDurationMinimumSecond = null;
      this.searchMissionDurationMinimumMinute = null;
      this.searchMissionDurationMinimumHoure = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCMissionTimesReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchFirstUserId,
        this.searchSecondUserId,
        this.searchPhoneCode,
        this.searchVehicleTypeId,
        this.searchCityId,
        this.searchDispatchTillMoveMinimumSecond,
        this.searchDispatchTillMoveMinimumMinute,
        this.searchMoveTillArriveMinimumSecond,
        this.searchMoveTillArriveMinimumMinute,
        this.searchPatientWaitingDurationMinimumSecond,
        this.searchPatientWaitingDurationMinimumMinute,
        this.searchHospitalWaitingDurationMinimumSecond,
        this.searchHospitalWaitingDurationMinimumMinute,
        this.searchMissionDurationMinimumSecond,
        this.searchMissionDurationMinimumMinute,
        this.searchMissionDurationMinimumHoure,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchFirstUserId = null;
      this.searchSecondUserId = null;
      this.searchPhoneCode = null;
      this.searchVehicleTypeId = null;
      this.searchCityId = null;
      this.searchDispatchTillMoveMinimumSecond = null;
      this.searchDispatchTillMoveMinimumMinute = null;
      this.searchMoveTillArriveMinimumSecond = null;
      this.searchMoveTillArriveMinimumMinute = null;
      this.searchPatientWaitingDurationMinimumSecond = null;
      this.searchPatientWaitingDurationMinimumMinute = null;
      this.searchHospitalWaitingDurationMinimumSecond = null;
      this.searchHospitalWaitingDurationMinimumMinute = null;
      this.searchMissionDurationMinimumSecond = null;
      this.searchMissionDurationMinimumMinute = null;
      this.searchMissionDurationMinimumHoure = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    convertToRankColor: function (rankNumber) {
      switch (rankNumber) {
        case 0:
          return '#ebebeb';
        case 1:
          return '#2eba7f';
        case 2:
          return '#ffbd55';
        case 3:
          return '#da6757';
        default:
          return '#ebebeb';
      }
    },
    convertToRankTitle: function (rankNumber) {
      switch (rankNumber) {
        case 0:
          return 'سفید';
        case 1:
          return 'سبز';
        case 2:
          return 'زرد';
        case 3:
          return 'قرمز';
        default:
          return 'نامشخص';
      }
    },
  },
  computed: {
    excelTableData: function () {
      return [...this.tableItems].map(({ sendAgain, lackof, ...rest }) => {
        const sendAgainTxt = sendAgain ? 'بله' : 'خیر';
        const lackofTxt = lackof ? 'بله' : 'خیر';
        return {
          ...rest,
          sendAgain: sendAgainTxt,
          lackof: lackofTxt,
        };
      });
    },
  },
};
